const translations = {
    // Form labels and helpers
    "firstName": "שם פרטי",
    "lastName": "שם משפחה",
    "selectMultipleRoles": "יש אפשרות לבחור כמה תפקידים",
    "selectMultipleBranches": "יש אפשרות לבחור כמה סניפים",
    
    // Tooltips
    "save": "שמור",
    "cancelChanges": "בטל שינויים"
};

export default translations;